export default __webpack_public_path__ + "static/media/stars-icon.f68af9f4.svg";